// export default EmiSchedule;
import React, { useState, useEffect } from "react";

// Month names array
const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const EmiSchedule = ({
    loanAmount = 1000000,
    rate = 6.5,
    tenure = 20, // years
}) => {
    const [schedule, setSchedule] = useState([]);
    const [openYear, setOpenYear] = useState(null);

    useEffect(() => {
        generateSchedule();
    }, [loanAmount, rate, tenure]);

    const generateSchedule = () => {
        const r = rate / 12 / 100; // monthly interest
        const n = tenure * 12; // total months
        const emi = (loanAmount * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);

        let balance = loanAmount;
        let scheduleMap = {}; // key = year, value = months array
        const today = new Date();
        let currentMonthIndex = today.getMonth(); // 0-11
        let currentYear = today.getFullYear();

        for (let i = 0; i < n; i++) {
            const interest = balance * r;
            const principal = emi - interest;
            balance -= principal;

            const monthName = monthNames[currentMonthIndex];

            // Initialize year array if not exists
            if (!scheduleMap[currentYear]) scheduleMap[currentYear] = [];

            scheduleMap[currentYear].push({
                month: monthName,
                principal: Math.round(principal),
                interest: Math.round(interest),
                emi: Math.round(emi),
                balance: Math.round(balance > 0 ? balance : 0),
            });

            // Move to next month
            currentMonthIndex++;
            if (currentMonthIndex > 11) {
                currentMonthIndex = 0;
                currentYear++;
            }
        }

        // Convert scheduleMap to array for rendering
        const scheduleArray = Object.keys(scheduleMap).map((year) => ({
            year,
            months: scheduleMap[year],
        }));

        setSchedule(scheduleArray);
    };

    return (
        <div className="emi-wrapper">
            <h2>EMI Payment Schedule</h2>

            {schedule.map((yearItem) => (
                <div key={yearItem.year} className="year-card">
                    {/* Header */}
                    <div
                        className="year-header"
                        onClick={() =>
                            setOpenYear(openYear === yearItem.year ? null : yearItem.year)
                        }
                    >
                        <div>
                            <strong>{yearItem.year}</strong>
                            <p>Monthly payment</p>
                        </div>

                        <span className="toggle-text">
                            {openYear === yearItem.year
                                ? "Hide Monthly Breakup ▲"
                                : "Show Monthly Breakup ▼"}
                        </span>
                    </div>

                    {/* Expand */}
                    {openYear === yearItem.year && (
                        <div className="table-wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Month</th>
                                        <th>Principal</th>
                                        <th>Interest</th>
                                        <th>Total Payment</th>
                                        <th>Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {yearItem.months.map((m, index) => (
                                        <tr key={index}>
                                            <td>{m.month}</td>
                                            <td>₹ {m.principal}</td>
                                            <td>₹ {m.interest}</td>
                                            <td>₹ {m.emi}</td>
                                            <td>₹ {m.balance}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default EmiSchedule;
